<template>
  <div class="admin">
    <div class="flex justify-between items-center pb-6 shadow-border-b mdmax:shadow-none mdmax:flex-col">
      <div class="flex-1 mdmax:flex-auto mdmax:w-full mdmax:mb-2">
        <LinkButton :buttonText="$t('admin.list.addUser')" url="/admin/create" linkType="internal"
          :size="isMobile ? 'full' : 'regular'" />
      </div>
      <div class="flex-1 flex gap-6 justify-end mdmax:flex-auto mdmax:w-full mdmax:justify-start">
        <!-- <div class="w-1/2  mdmax:w-full">
          <label class="text-base text-neutral-700 font-medium mb-1 inline-block">Partner</label>
          <CustomSelect :options="partnerList" v-model="selectedPartner" :default="selectedPartner" placeholder="Pilih partner" optionLabel="name" />
        </div>
        <div class="w-1/2  mdmax:w-full">
          <label class="text-base text-neutral-700 font-medium mb-1 inline-block">Pencarian</label>
          <div class="relative">
            <TextField type="text" :withIcon="true" placeholder="Pencarian nama" v-model="searchTerm" @enter="doSearch()" />
            <div class="absolute left-3 top-1/2 transform -translate-y-1/2">
              <Search />
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <TableComponent :columns="columns" :list="filteredData">
      <template slot="table-row" slot-scope="{ entry, column }">
        <LinkButton v-if="column.field === 'action'" :buttonText="$t('admin.list.moreDetail')" :url="`/admin/detail/${entry.id}`"
          linkType="internal" type="secondary" size="small" />
        <span class="block" v-else-if="column.field === 'created_at'">
          {{ entry[column.field] | formatDate }}
        </span>
        <span class="block break-all" v-else-if="column.field === 'id'">
          {{ entry[column.field] }}
        </span>
        <span v-else>{{ entry[column.field] }}</span>
      </template>
    </TableComponent>
    <div class="text-neutral-500 font-medium mt-2 text-sm" v-if="!isMobile">{{ $t('ongkir.show') }} {{ start }} - {{ end
      }}
      {{ $t('ongkir.from') }} {{
        totalRecords }}</div>
    <div class="mt-8 flex justify-center items-center mb-6" v-if="filteredData && filteredData.length > 0">
      <pagination :currentPage="currentPage" :totalCount="totalRecords" :pageSize="pageSize"
        @onPageChange="onPageChange" />
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { formatDate } from '@/util'
export default {
  filters: {
    formatDate
  },
  components: {
    // Search: () => import(/* webpackChunkName: "Icons" */ '@/components/Icons/Search'),
    TableComponent: () => import(/* webpackChunkName: "Table" */ '@/components/Table/Table'),
    // TextField: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/TextField'),
    LinkButton: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/LinkButton'),
    // CustomSelect: () => import(/* webpackChunkName: "Forms" */ '@/components/Forms/CustomSelect'),
    Pagination: () => import(/* webpackChunkName: "Pagination" */ '@/components/Pagination/Pagination')
  },
  data: () => ({
    selectedPartner: '',
    searchTerm: '',
    totalRecords: 0,
    currentPage: 1,
    pageSize: 10,
    hasMorePages: true,
    // columns: [
    //   { label: 'ID', field: 'id' },
    //   { label: 'Nama', field: 'name' },
    //   { label: 'Email', field: 'email' },
    //   { label: 'No Handphone', field: 'phone_number' },
    //   { label: 'Action', field: 'action' }
    // ]
  }),
  computed: {
    ...mapGetters('auth', ['userData']),
    ...mapGetters('merchant', ['merchantUsers']),
    ...mapGetters('common', ['isMobile']),
    filteredData() {
      let temp = this.merchantUsers || []
      temp = temp.filter(item => {
        return item.id !== ''
      })
      return temp
    },
    start() {
      return (this.currentPage - 1) * this.pageSize + 1
    },
    end() {
      const lastOnPage = (this.currentPage - 1) * this.pageSize + this.pageSize
      return lastOnPage > this.totalRecords ? this.totalRecords : lastOnPage
    },
    columns() {
      return [
        { label: this.$t('admin.list.id'), field: 'id' },
        { label: this.$t('admin.list.name'), field: 'name' },
        { label: this.$t('admin.list.email'), field: 'email' },
        { label: this.$t('admin.list.phone'), field: 'phone_number' },
        { label: this.$t('admin.list.action'), field: 'action' }
      ]
    }
  },
  methods: {
    ...mapActions('merchant', ['getMerchantUsers']),
    ...mapActions('common', ['showLoading', 'hideLoading']),
    getMerchantUserList() {
      this.showLoading()
      this.getMerchantUsers({
        params: {
          page: this.currentPage,
          per_page: this.pageSize,
          sort: 'DESC'
        }
      })
        .then(res => {
          this.totalRecords = res.data.meta.total_item
          this.hideLoading()
        })
        .catch(() => {
          this.hideLoading()
        })
    },
    showMore(page) {
      this.$router.push({ path: '/admin', query: { page: page } })
      this.page = page
      this.currentPage = page
    },
    onPageChange(page) {
      this.currentPage = page
      this.$router.push({ path: '/admin', query: { page: page } })
    },
    goToDetail(target) {
      this.$router.push(`/admin/detail/${target}`)
    }
  },
  created() {
    if (!this.$route.query.page) {
      this.$router.push({ path: '/admin', query: { page: 1 } })
      this.page = 1
      this.currentPage = 1
    } else {
      this.page = parseInt(this.$route.query.page)
      this.currentPage = parseInt(this.$route.query.page)
      this.getMerchantUserList()
    }
  },
  watch: {
    $route(val) {
      if (val.query.page) {
        this.page = parseInt(val.query.page)
        this.currentPage = parseInt(val.query.page)
        this.getMerchantUserList()
      } else {
        this.$router.push({ path: '/admin', query: { page: 1 } })
        this.page = 1
        this.currentPage = 1
      }
    }
  }
}
</script>
